import React from 'react';
import {
    FormGroup,
    Label,
    Input,
    InputGroup,
    InputGroupAddon,
    ListGroup,
    ListGroupItem,
    Button
} from 'reactstrap';
import cn from 'classnames';


import Dropzone from 'react-dropzone';

const defaultMsg = "Arrastra o selecciona un archivo";

function defaultQuestion() {
    return {
        question : 'Pregunta',
        communique_answers : [
            {
                points : 1,
                answer : 'Respuesta1',
            },
            {
                points : 0,
                answer : 'Respuesta2',
            },
            {
                points : 0,
                answer : 'Respuesta3',
            },
            {
                points : 0,
                answer : 'Respuesta4',
            },
        ]
    };
}

export default class CommuniqueForm extends React.Component {

    constructor(props) {
        super(props);
        this.onDrop = this._onDrop.bind(this);
        this.onDragEnter = this._onDragEnter.bind(this);
        this.onDragLeave = this._onDragLeave.bind(this);
        this.uploadMessage = this._uploadMessage.bind(this);
        this.editAnswer = this._editAnswer.bind(this);
        this.editQuestion = this._editQuestion.bind(this);
        this.markAsCorrect = this._markAsCorrect.bind(this);
        this.addQuestion = this._addQuestion.bind(this);
        this.removeQuestion = this._removeQuestion.bind(this);
        this.store = this._store.bind(this);
        this.state = {
            name : '',
            file : {
                name : '',
                file : null,
            },
            cover : {
                name : '',
                file : null,
            },
            communique_questions : [
                defaultQuestion(),
            ]
        }
    }

    componentWillReceiveProps(props) {
        console.log()
        if(this.props.communiques.posting && ! props.communiques.posting && props.communiques.errors === null) {
            // Communique was stored succesfully
            this.props.router.push('/communiques');
        }
    }

    _store() {
        this.props.storeCommunique({
            name : this.state.name,
            file : this.state.file.file,
            cover : this.state.cover.file,
            questions : this.state.communique_questions
        })
    }

    _editAnswer(questionIdx, answerIdx, value) {
        const state = {...this.state};
        state.communique_questions[questionIdx].communique_answers[answerIdx].answer = value;
        this.setState(state);
    }

    _editQuestion(questionIdx, value) {
        const state = {...this.state};
        state.communique_questions[questionIdx].question = value;
        this.setState(state);
    }

    _markAsCorrect(questionIdx, answerIdx) {
        const state = {...this.state}
        for(let i=0; i< state.communique_questions[questionIdx].communique_answers.length; i++) {
            state.communique_questions[questionIdx].communique_answers[i].points = i === answerIdx ? 1 : 0;
        }
        this.setState(state);
    }

    _addQuestion() {
        this.setState({
            communique_questions : [
                ...this.state.communique_questions,
                defaultQuestion(),
            ]
        });
    }

    _removeQuestion(questionIdx) {
        this.setState(prevState => {
            return {
                communique_questions : [
                    ...prevState.communique_questions.slice(0, questionIdx),
                    ...prevState.communique_questions.slice(questionIdx + 1),
                ]
            }
        })
    }

    _uploadMessage(dzName) {
        const dropzone = this.refs[dzName];
        let message = defaultMsg;
            
        try {
            const dropState = dropzone.state;
            if(dropState.isDragActive) {
                message = "Suelta tu archivo aquí";
            }else if(dropState.isDragReject) {
                message = "Por favor, solo selecciona archivos XLSX";
            }
        }catch(e) {}

        return message;
    }

    _onDrop(dzName, accepted, rejected) {
        if(accepted.length === 1 && rejected.length === 0) {
            const file = accepted[0];
            this.setState({
                [dzName === 'coverDropzone' ? 'cover' : 'file'] : {
                    name : file.name,
                    file : file,
                }
            })
        }else if(accepted.length > 0) {
            this.showError("Por favor, selecciona únicamente un archivo");
        }
        let message = defaultMsg;
        this.setState({
            dropMessage : message
        });
        
    }

    _onDragEnter(dzName, evt) {
        let message = this.uploadMessage(dzName);
        this.setState({
            dropMessage : message
        });
    }

    _onDragLeave(dzName, vt) {
        this.setState({
            dropMessage : 'ASDASD'
        });
    }

    render() {
        const errors = this.props.communiques.errors || {};
        const {posting, progress} = this.props.communiques;
        return (
            <div className="container">
                <div className="row">
                    <fieldset className="col-md-4">
                        <legend>Material</legend>
                        <FormGroup color={(errors.name || []).length > 0 ? 'danger' : null}>
                            <Label for="nameInput">
                                Título
                            </Label>
                            <Input type="text" maxLength={50} id="nameInput" value={this.state.name} onChange={(event) => this.setState({name : event.target.value})}/>
                            {
                                (errors.name || []).map(error => (
                                    <p className="form-control-feedback">
                                        {error}
                                    </p>
                                ))
                            }
                        </FormGroup>
                        <FormGroup color={(errors.cover || []).length > 0 ? 'danger' : null}>
                            <Label>Portada</Label>
                            {
                                (errors.cover || []).map(error => (
                                    <p className="form-control-feedback">
                                        {error}
                                    </p>
                                ))
                            }
                            <Dropzone
                            ref="coverDropzone"
                            className="dropzone"
                            activeClassName="active"
                            rejectClassName="reject"
                            accept={"image/*"}
                            onDrop={(accepted, rejected) => this.onDrop('coverDropzone', accepted, rejected)}
                            onDragEnter={(evt) => this.onDragEnter('coverDropzone', evt)}
                            onDragLeave={(evt) => this.onDragLeave('coverDropzone', evt)}>
                                {
                                    this.state.cover.name ? this.state.cover.name : 'Arrastra o selecciona una portada'
                                }
                            </Dropzone>
                        </FormGroup>
                        <FormGroup color={(errors.file || []).length > 0 ? 'danger' : null}>
                            <Label>Archivo (mp4 o pdf)</Label>
                            {
                                (errors.file || []).map(error => (
                                    <p className="form-control-feedback">
                                        {error}
                                    </p>
                                ))
                            }
                            
                            <Dropzone
                            ref="fileDropzone"
                            className="dropzone"
                            activeClassName="active"
                            rejectClassName="reject"
                            accept={".mp4,.pdf"}
                            onDrop={(accepted, rejected) => this.onDrop('fileDropzone', accepted, rejected)}
                            onDragEnter={(evt) => this.onDragEnter('fileDropzone', evt)}
                            onDragLeave={(evt) => this.onDragLeave('fileDropzone', evt)}>
                                {
                                    this.state.file.name ? this.state.file.name : 'Archivo'
                                }
                            </Dropzone>
                        </FormGroup>
                        
                    </fieldset>

                    <fieldset className="col-md-8">
                        <legend>
                            Evaluación
                        </legend>
                        <div className="form-group has-danger">
                            {

                                (errors.questions || []).map(error => (
                                    <p className="form-control-feedback">
                                        {error}
                                    </p>
                                ))
                            }
                        </div>
                        {
                            this.state.communique_questions.map((question, i) => (
                                <div className="card mb-1" key={i}>
                                    <div className="card-block">
                                        <h5 className="card-title mb-0">
                                            <button type="button" className="close pull-right" aria-label="Close" onClick={() => this.removeQuestion(i)}>
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                            <Input value={question.question} type="text" onClick={event => event.stopPropagation() } onChange={event => this.editQuestion(i, event.target.value)} />
                                        </h5>
                                    </div>
                                    <ListGroup>
                                        {question.communique_answers.map((answer, j) => (
                                            <ListGroupItem key={j} active={answer.points > 0 ? true : null} onClick={() => this.markAsCorrect(i,j)}>

                                                <InputGroup>
                                                    <InputGroupAddon>
                                                        <i className={cn("pull-right", "fa", "fa-fw", {'fa-check' : answer.points > 0, 'fa-circle-o' : answer.points === 0})}></i>
                                                    </InputGroupAddon>
                                                    <Input value={answer.answer} type="text" onClick={event => event.stopPropagation() } onChange={event => this.editAnswer(i, j, event.target.value)} />
                                                </InputGroup>
                                            </ListGroupItem>
                                        ))}
                                    </ListGroup>
                                </div>
                            ))
                        }
                        {
                            posting ?
                                <div className="progress w-100">
                                    <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100} style={{width: progress + '%'}}></div>
                                </div>
                            :
                            <div className="text-right mt-2">
                                <Button className="mr-1">Cancelar</Button>
                                <Button className="mr-1" color="info" onClick={this.addQuestion}>Agregar pregunta </Button>
                                <Button color="primary" onClick={this.store}>Guardar</Button>
                            </div>    
                        }
                        
                    </fieldset>
                </div>
            </div>
            
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/communiques/CommuniqueForm.jsx
 **/